<template>
  <div class="wrapper wrapper-content animated fadeIn">
    <div class="row">
      <div class="col-lg-5">
        <div class="ibox float-e-margins">
          <div class="ibox-content mailbox-content">
            <form v-on:submit.prevent="createPriceTicket">
              <h2>Cadastro de preços</h2>
              <div class="space-25"></div>

              <div class="form-group">
                <label>Preço</label>
                <input
                  type="text"
                  placeholder="Digite o valor debitado"
                  class="form-control"
                  v-model="form.price"
                />
              </div>
              <div class="form-group">
                <label>Valor adicionado na carteira</label>
                <input
                  type="text"
                  placeholder="Digite o valor que será adicionado na carteira"
                  class="form-control"
                  v-model="form.creditToUser"
                />
              </div>
              <div class="form-group">
                <label>Label</label>
                <input
                  type="text"
                  placeholder="Digite o que será exibido para o cliente"
                  class="form-control"
                  v-model="form.label"
                />
              </div>
              <div class="form-group">
                <label>Descrição</label>
                <input
                  type="text"
                  placeholder="Digite uma descrição"
                  class="form-control"
                  v-model="form.description"
                />
              </div>

              <button
                class="btn btn-block btn-primary compose-mail"
                href="mail_compose.html"
                v-if="!form.control.editModeId"
              >
                <i class="fa fa-save"></i>
                Criar ticket
              </button>

              <div v-if="form.control.editModeId">
                <button
                  class="btn btn-outline"
                  href="mail_compose.html"
                  :disabled="form.control.createButtonIsDisabled"
                  @click="disableEditMode"
                >
                  Cancelar
                </button>

                <button
                  class="btn btn-warning pull-right"
                  href="mail_compose.html"
                  :disabled="
                    form.control.createButtonIsDisabled || !permissionUpdate
                  "
                  @click="saveEdition"
                >
                  <i class="fa fa-save"></i>
                  Salvar ticket
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-lg-7 animated fadeInRight">
        <div class="mail-box-header">
          <h2>Lista de tickets de preço</h2>

          <form>
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                v-model="searchForm.form.label"
              />

              <div class="input-group-btn">
                <button
                  type="button"
                  class="btn btn-sm btn-primary"
                  @click="searchPriceTicket"
                  v-if="permissionRead"
                >
                  <i class="fa fa-search"></i>
                  Buscar
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="mail-box">
          <table class="table table-hover table-mail">
            <thead class="table-head">
              <tr>
                <th>Label</th>

                <th></th>
                <th></th>
              </tr>
            </thead>

            <tbody class="table-list">
              <tr
                :class="{ unread: listItem.accountEnabled }"
                v-for="(listItem, listIdx) in registerList.list"
                :key="listIdx"
              >
                <td>{{ listItem.label }}</td>

                <td class="list-command">
                  <button
                    class="btn btn-outline"
                    @click="enterEditMode(listItem, listIdx)"
                    v-if="permissionUpdate"
                  >
                    <i class="fa fa-edit text-success"></i>
                  </button>
                </td>
                <td class="list-command">
                  <button
                    class="btn btn-outline"
                    title="Excluir funcionário"
                    v-if="permissionDelete"
                    @click="removePlan(listItem)"
                  >
                    <i class="fa fa-trash text-danger"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  // name: 'RegisterPriceTicket',

  data() {
    return {
      form: {
        label: '',
        price: '',
        creditToUser: '',
        description: '',
        control: {
          editModeId: false,
          createButtonIsDisabled: false,
        },
      },
      searchForm: {
        form: {
          label: '',
        },
        control: {},
      },
      registerList: {
        originalList: [],
        list: [],
        control: {},
      },
    };
  },
  computed: {
    permissionCreate() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'price-ticket',
        'CREATE',
      );
    },
    permissionRead() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'price-ticket',
        'READ',
      );
    },
    permissionUpdate() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'price-ticket',
        'UPDATE',
      );
    },
    permissionDelete() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'price-ticket',
        'DELETE',
      );
    },
  },
  watch: {
    'searchForm.form.label'() {
      this.searchPriceTicket();
    },
  },
  mounted() {
    this.listPriceTicket();
  },
  methods: {
    async listPriceTicket() {
      if (!this.permissionRead) {
        return;
      }
      const priceList = await this.$store.dispatch('PRICE-TICKET/ListAll');
      this.registerList.originalList = priceList;
      this.searchPriceTicket();
    },
    searchPriceTicket() {
      if (!this.permissionRead) {
        return;
      }

      const listFiltered = this.registerList.originalList.filter((item) => {
        return (
          item.label
            .toUpperCase()
            .indexOf(this.searchForm.form.label.toUpperCase()) > -1
        );
      });
      this.registerList.list = listFiltered;
    },
    resetPriceTicketForm() {
      this.form.control.editModeId = false;
      this.form.label = '';
      this.form.creditToUser = '';
      this.form.price = '';
      this.form.description = '';
    },
    enterEditMode(registerItem) {
      this.form.control.editModeId = registerItem._id;
      this.form.label = registerItem.label;
      this.form.price = registerItem.price;
      this.form.creditToUser = registerItem.creditToUser;
      this.form.description = registerItem.description;
    },
    disableEditMode() {
      this.resetPriceTicketForm();
    },
    async saveEdition() {
      this.form.control.createButtonIsDisabled = true;

      const id = this.form.control.editModeId;
      const payload = {
        ...this.form,
        control: undefined,
      };

      try {
        await this.$store.dispatch('PRICE-TICKET/Update', {
          payload,
          id,
        });
        this.listPriceTicket();

        this.resetPriceTicketForm();

        this.$toasted.success('Ticket salvo com sucesso');
      } catch (error) {
        console.error(error);
        this.$toasted.error(error.error);
      } finally {
        this.form.control.createButtonIsDisabled = false;
      }
    },
    async createPriceTicket() {
      if (!this.permissionCreate) {
        return;
      }

      const payload = {
        ...this.form,

        control: undefined,
      };

      try {
        await this.$store.dispatch('PRICE-TICKET/Create', payload);
        this.listPriceTicket();

        this.resetPriceTicketForm();
        this.$toasted.success('Ticket inserido com sucesso');
      } catch (error) {
        this.$toasted.error(error.error);
      } finally {
        this.form.control.createButtonIsDisabled = false;
      }
    },
    async removePlan({ label, _id }) {
      if (
        confirm(
          `Deseja deletar o ticket ${label}? Essa operação não tem volta.`,
        )
      ) {
        try {
          const id = _id;
          await this.$store.dispatch('PRICE-TICKET/Remove', {
            id,
          });
          this.listPriceTicket();
          this.$toasted.success('Ticket removido com sucesso');
        } catch (error) {
          this.$toasted.error(error.error);
        }
      }
    },
  },
};
</script>